import { render, staticRenderFns } from "./ChatSettings.vue?vue&type=template&id=23da31b2&"
import script from "./ChatSettings.vue?vue&type=script&lang=js&"
export * from "./ChatSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports